import { useRefinementList } from "react-instantsearch";
import { m } from "#/paraglide/messages";

type AlgoliaRefinementListProps = {
	attribute: string;
	title?: string;
};

export default function AlgoliaRefinementList({
	attribute,
	title = m.search_tags(),
}: AlgoliaRefinementListProps) {
	const { items, refine } = useRefinementList({
		attribute,
		limit: 50,
	});
	if (items.length === 0) return null;

	return (
		<div className="search-page-tags">
			<aside className="search-page-filters" aria-label={title}>
				<div className="flex flex-col gap-4">
					<h2 className="h6 fs-lg-5 mb-0">{title}</h2>
					<ul className="m-0 flex list-none flex-wrap gap-2 p-0">
						{items.map((item) => (
							<li key={item.value}>
								<button
									aria-pressed={item.isRefined}
									className={`tag ${item.isRefined ? "active" : "inactive"}`}
									onClick={() => refine(item.value)}
									type="button"
								>
									<span>{item.label}</span>
									<span className="tag-count">{item.count}</span>
								</button>
							</li>
						))}
					</ul>
				</div>
			</aside>
		</div>
	);
}
